var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Transition',{attrs:{"name":"slide-left"}},[(_vm.isVisible)?_c('div',{class:_setup.transitionClass},[_vm._t("default"),_c(_setup.VsBottomSheet,{attrs:{"is-visible":_vm.isBottomDrawerVisible}},[_vm._t("bottom-drawer")],2)],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }